import { Box, Checkbox, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface IndustrySelectorItemProps {
	name: string;
	value: number[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>;
	industries: { id: number; name: string }[];
	error?: string;
}

export default function IndustrySelectorItem({
	name,
	value = [],
	setValue,
	industries,
	error,
}: IndustrySelectorItemProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-questionnaire.${key}`);

	const handleChange = (event: SelectChangeEvent<number[]>) => {
		const selected = event.target.value as number[];

		setValue(name, selected, {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	return (
		<Select
			displayEmpty
			fullWidth
			multiple
			error={!!error}
			renderValue={(selected: unknown) =>
				Array.isArray(selected) && selected.length > 0
					? selected
							.map((id) => industries.find((i) => i.id === id)?.name)
							.filter(Boolean)
							.join(", ")
					: ts("select-industry")
			}
			value={value}
			onChange={handleChange}
		>
			{industries.map((industry) => (
				<MenuItem key={industry.id} value={industry.id}>
					<Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
						<Checkbox checked={value.includes(industry.id)} sx={{ padding: "4px" }} />
						<Typography component="span" sx={{ m: 0 }}>
							{industry.name}
						</Typography>
					</Box>
				</MenuItem>
			))}
		</Select>
	);
}
